import React from 'react';
import { Card } from '@/components';
import styled from 'styled-components';
// css书写规范：定位/显示 > 盒模型 > 排版 > 外观 > mixin
const Root = styled.div `
  .card-item{
    width: 30%;
  }
`;
const TotalCard = (props) => {
    return (<Card className={props.className} themeColor="rgb(83, 197, 210)" title="保证金总额" num={props.num} unit="元"/>);
};
const AvailableCard = (props) => {
    return (<Card className={props.className} themeColor="rgb(53,152,220)" title="可用保证金总额" num={props.num} unit="元"/>);
};
const FrozenCard = (props) => {
    return (<Card className={props.className} themeColor="rgb(231, 81, 91)" title="冻结保证金总额" num={props.num} unit="元"/>);
};
export const CardPart = (props) => {
    return (<Root className="flex__row-bt">
          <AvailableCard className="card-item" num={props.aMoney}/>
          <FrozenCard className="card-item" num={props.fMoney}/>
          <TotalCard className="card-item" num={props.tMoney}/>
        </Root>);
};
